import { Component, Element, Event, EventEmitter, h, Host, Prop } from '@stencil/core'
import { noop } from 'lodash-es'
import { css } from 'src/lib/emotion'
import { RenderFn } from 'src/types'

import { classes, hasPosition } from '../../utils/css'

const anchors = css`
  & > * {
    position: absolute;
    top: 0;
    transform: translate(-50%, -50%);
  }
`

const spans = css`
  & > * {
    position: absolute;
    top: 0;
    transform: translate(0, -50%);
  }
`
@Component({
  tag: 'ui-playhead',
})
export class Playhead {
  @Element() el: HTMLUiPlayheadElement

  @Event() clicked: EventEmitter<number>

  @Prop() position = 0
  @Prop() allowClick = false

  @Prop() renderActions = noop as RenderFn
  @Prop() renderSpans = noop as RenderFn
  @Prop() renderMarkers = noop as RenderFn
  @Prop() renderPlayhead = noop as RenderFn

  hasPosition: boolean

  componentWillLoad() {
    this.hasPosition = hasPosition(this.el)
  }

  render() {
    return (
      <Host
        class={`flex h-1 rounded-full bg-surface-higher ${classes(!this.hasPosition, 'relative')}`}
        onClick={(e: MouseEvent) => {
          if (this.allowClick) {
            // First figure out the global position of this element (the playhead)
            const rect = this.el.getBoundingClientRect()
            // Then take the global x position of the mouse click and figure out where sits locally (on the playhead)
            const x = Math.floor(e.clientX - rect.left)
            // Now figure out what percentage of the total width that is
            const pct = x / this.el.clientWidth
            // And send it out
            this.clicked.emit(pct)
          }
        }}
      >
        <div class={`absolute h-full left-0 right-0 transform ${spans}`} style={{ top: '50%' }}>
          {this.renderSpans()}
        </div>
        <div class={`absolute left-0 right-0 transform ${anchors}`} style={{ top: '50%' }}>
          {this.renderMarkers()}
        </div>
        <div
          class='absolute transform -translate-x-1/2 -translate-y-1/2'
          style={{ top: '50%', left: this.position * 100 + '%' }}
          onClick={(e) => e.stopImmediatePropagation()}
        >
          {this.renderPlayhead() || <div class='w-1 h-4 bg-link rounded-full shadow-contrast' />}
        </div>
      </Host>
    )
  }
}
